import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';


function CallStatus(props) {
    let content = <FontAwesomeIcon className="text-danger" size="lg" icon={duotone("phone-arrow-down-left")} />;
    if (props.call.status === "ACD_RING") {
        content = <FontAwesomeIcon className="text-warning" size="lg" icon={duotone("bell-on")} />;
    }

    if (props.call.status === "DETE") {
        content = <FontAwesomeIcon style={{ color: "#6610f2" }} size="lg" icon={duotone("phone-arrow-down-left")} />;
    }

    return content;
}


export default CallStatus;